"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDrillToLegacyDashboard = void 0;
// (C) 2020-2021 GoodData Corporation
var model_1 = require("../../../model");
/**
 * @internal
 */
exports.useDrillToLegacyDashboard = function (_a) {
    var _b = _a === void 0 ? {} : _a, onSuccess = _b.onSuccess, onError = _b.onError, onBeforeRun = _b.onBeforeRun;
    return model_1.useDashboardCommandProcessing({
        commandCreator: model_1.drillToLegacyDashboard,
        successEvent: "GDC.DASH/EVT.DRILL.DRILL_TO_LEGACY_DASHBOARD.RESOLVED",
        errorEvent: "GDC.DASH/EVT.COMMAND.FAILED",
        onSuccess: onSuccess,
        onError: onError,
        onBeforeRun: onBeforeRun,
    });
};
//# sourceMappingURL=useDrillToLegacyDashboard.js.map